import React from 'react'
import Chevron from '../assets/svg/chevron_down.inline.svg'

// "to" prop is a element ID
const ScrollBtn = ({ to }) => {
  const scrollToElement = () => {
    let whereToScroll = document.getElementById(to)

    window.scrollTo({
      top: whereToScroll.offsetTop,
      left: 0,
      behavior: 'smooth',
    })
  }

  return (
    <button
      onClick={scrollToElement}
      className='flex flex-col self-center items-center uppercase mb-[12px] md:mb-[24px] group hover:text-gray-300 transition-all ease-in-out duration-300 no-underline'
    >
      <span className='flex justify-center py-[3px] mb-[5px] bg-white/[.45] w-[24px] h-[40px] rounded-[40px] overflow-hidden relative'>
        <span className='scroll-btn__inner bg-white/[.45] transition-all ease-in-out duration-300 group-hover:translate-y-[95%]'>
          <Chevron />
        </span>
      </span>
      scroll
    </button>
  )
}

export default ScrollBtn
